import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

axiosInstance.interceptors.request.use((config)=>{
    const access_token = localStorage.getItem('token');
    if(access_token){
        config.headers["Authorization"] = `Bearer ${access_token}`;
    }
    return config
})

export default axiosInstance;